<template>
  <div class="stats">
    <div class="col-md-3 col-xs-12">
      <users-list
        @selectUser="selectUser"
        :users="filtred"
        :loading="usersLoading"
      >
        <template slot="counters">
          <div class="counters">
            <h1>{{ $formatNumber(currentCounters.result_str) }}</h1>
            <span v-if="currentCounters.result > 0">долг</span>
            <span v-else>авансирование</span>
            <span v-if="currentCounters.result === 0"> </span>
          </div>
        </template>
        <template slot="directions" v-if="data.admin">
          <div class="-cell">
            <label>Роль</label>
            <custom-select-multiple
              :name="'Role'"
              @valuesSelected="valuesSelected"
              :options="Role"
            />
          </div>
        </template>
        <template slot="directions" v-if="data.admin">
          <div class="-cell">
            <label>Направление</label>
            <custom-select-multiple
              :name="'Directions'"
              @valuesSelected="valuesSelected"
              :options="Directions"
            />
          </div>
        </template>
      </users-list>
    </div>
    <div class="col-md-9 col-xs-12">
      <graph-stats
        :statsData="stats_data"
        :mobile="$mediaQuery() === 'mobile'"
        :title="stats_title"
      ></graph-stats>
      <table-stats
        :stats="stats"
        :counters="currentCounters"
        :hide-average="false"
      ></table-stats>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import tableStats from "@/components/finance/table-stats.vue";
import usersList from "@/components/finance/users-list.vue";
import graphStats from "@/components/finance/graph-stats.vue";
import { average, processPayoutArray } from "../../plugins/_helpers";

export default {
  components: {
    tableStats,
    usersList,
    graphStats
  },
  computed: {
    ...mapState("user", ["data"]),
    ...mapState("app", ["roles", "directions", "users_list"]),
    ...mapState("finance", ["stats", "stats_data"]),
    ...mapGetters("app", ["resolveUser"])
  },
  methods: {
    ...mapActions("app", ["getUsersList"]),
    ...mapActions("finance", ["getStatsData", "setStatsQuery"]),
    valuesSelected({ name, option }) {
      this.save = true;
      if (option.value !== 0) {
        this.save = true;
        this[name].map(v => {
          if (option.value === v.value) v.selected = !option.selected;
        });
        const endValues = this[name].filter(v => v.selected).map(v => v.value);

        const zeroIndex = endValues.findIndex(v => v.value === 0);
        if (zeroIndex > -1) endValues.splice(zeroIndex, 1);

        const selectedIndex = this[name].findIndex(v => v.value === 0);
        if (selectedIndex > -1) this[name][selectedIndex].selected = false;
      } else this[name].map(v => (v.selected = v.value === 0));

      this.filterUsers();
      this.prepareQuery();
      this.getStatsData();
    },
    prepareSelect() {
      this.Role = this.roles.map(role => {
        return {
          title: role.name,
          value: role.id,
          selected: role.id === 0
        };
      });
      this.Directions = this.directions.map(role => {
        return {
          title: role.name,
          value: role.id,
          selected: role.id === 0
        };
      });
    },
    filterUsers() {
      this.usersLoading = true;
      const fRoles = this.Role.filter(r => r.selected).map(r => r.value);
      const fDirections = this.Directions.filter(r => r.selected).map(
        r => r.value
      );

      if (fRoles[0] === 0 && fDirections[0] === 0)
        this.filtred = this.users_list;
      else {
        const filtredUsers = [];
        if (fRoles[0] !== 0 && fDirections[0] !== 0) {
          for (const u of this.users_list) {
            for (const r of fRoles) {
              for (const d of fDirections) {
                if (
                  u.role.includes(r) &&
                  u.directions.includes(d) &&
                  !filtredUsers.some(usr => u.email === usr.email)
                )
                  filtredUsers.push(u);
              }
            }
          }
        }
        if (fRoles[0] === 0 && fDirections[0] !== 0) {
          for (const u of this.users_list) {
            for (const d of fDirections) {
              if (
                u.directions.includes(d) &&
                !filtredUsers.some(usr => u.email === usr.email)
              )
                filtredUsers.push(u);
            }
          }
        }
        if (fRoles[0] !== 0 && fDirections[0] === 0) {
          for (const u of this.users_list) {
            for (const r of fRoles) {
              if (
                u.role.includes(r) &&
                !filtredUsers.some(usr => u.email === usr.email)
              )
                filtredUsers.push(u);
            }
          }
        }
        this.filtred = filtredUsers;
      }
      this.usersLoading = false;
    },
    async selectUser({ user, index }) {
      if (!this.filtred[index].selected) {
        for (const u of this.filtred) {
          u.selected = false;
        }
        this.$set(
          this.filtred,
          index,
          Object.assign(this.filtred[index], { selected: true })
        );

        this.prepareQuery(user.email);
      } else {
        // reset
        this.$set(
          this.filtred,
          index,
          Object.assign(this.filtred[index], { selected: false })
        );
        this.prepareQuery();
      }
      this.getStatsData();
    },
    prepareQuery(email) {
      if (email) {
        this.setStatsQuery({ email: email, directions: [], role: [] });
        const { first_name, last_name } = this.resolveUser(email);

        let title;

        if (this.$mediaQuery() === "mobile")
          title = `Статистика  ${
            first_name ? first_name.charAt(0) + "." + last_name : email
          }`;
        else
          title = `Статистика сотрудника ${
            first_name ? first_name + " " + last_name : email
          } `;

        this.stats_title = title;
      } else {
        let Dir = this.Directions.filter(d => d.selected).map(d => d.value);
        let Rol = this.Role.filter(d => d.selected).map(d => d.value);

        if (Dir.some(d => d === 0)) Dir = [];
        if (Rol.some(r => r === 0)) Rol = [];

        this.setStatsQuery({
          email: null,
          directions: Dir,
          role: Rol
        });
        if (Dir.length || Rol.length) this.stats_title = "Статистика группы";
        else this.stats_title = "Общая статистика";
      }
    },
    calcCounters() {
      const payout = processPayoutArray(this.stats);
      let payrollAverage = Math.round(
        average(
          this.stats.map(s => Math.abs(s.payroll)).filter(item => item > 0)
        )
      );
      let payoutAverage = Math.round(average(payout.filter(item => item > 0)));

      this.currentCounters.payroll = this.stats
        .map(s => s.payroll)
        .reduce((acc, v) => acc + (v || 0));

      this.currentCounters.payout = payout.reduce((acc, v) => acc + (v || 0));

      this.currentCounters.result =
        this.currentCounters.payroll - this.currentCounters.payout;
      this.currentCounters.result_str = (
        this.currentCounters.payroll - this.currentCounters.payout
      )
        .toString()
        .replace("-", "");

      this.currentCounters.payrollAverage = payrollAverage;
      this.currentCounters.payoutAverage = payoutAverage;
    }
  },
  async beforeMount() {
    await this.getUsersList();
    this.prepareSelect();
    await this.getStatsData();
  },

  mounted() {
    setTimeout(() => this.filterUsers(), 500);
  },
  watch: {
    stats: {
      deep: true,
      handler() {
        this.calcCounters();
      }
    }
  },
  data() {
    return {
      Role: [],
      Directions: [],
      filtred: [],
      usersLoading: true,
      stats_title: "Общая статистика",
      currentCounters: {
        payroll: 0,
        payout: 0,
        result: 0,
        payrollAverage: 0,
        payoutAverage: 0
      }
    };
  }
};
</script>
